import { EntitySearchFilterBar } from 'src/components/EntitySearch';
import { FilterDropdownItem } from 'src/components/Filters';
import { useSaleFilters } from 'src/components/MainFilterBar';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature, SaleQuery, SaleSearchResult } from 'src/WebApiController';

export const SaleSearchFilterBar = (props: {
  activeSearchConfig?: SaleSearchResult;
  onSubmitFilter?: (query: SaleQuery) => void;
  selectedFilters?: FilterDropdownItem[];
  setSelectedFilters: (sf: FilterDropdownItem[]) => void;
}) => {
  const hasSearchViewVenueFilterFeature = useUserHasFeature(
    Feature.SearchViewVenueFilter
  );

  const hasSearchViewPerformerFilterFeature = useUserHasFeature(
    Feature.SearchViewPerformerFilter
  );

  const { filters } = useSaleFilters({
    showCatalogFilters: true,
    showVenueFilter: hasSearchViewVenueFilterFeature,
    showPerformerFilter: hasSearchViewPerformerFilterFeature,
    isHorizontalLayout: true,
    firstRenderOpen: props.activeSearchConfig == null,
  });

  return (
    <EntitySearchFilterBar
      {...props}
      filters={filters}
      mandatoryFiltersToShow={['eventDates', 'eventOrMappingIds']}
    />
  );
};
